class CartRemoveButton extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', (event) => {
      event.preventDefault()

      publish(PUB_SUB_EVENTS.cartLoading, { source: 'cart-items' })

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items')
      const monoKey = this.getAttribute('data-fee-key')

      if (this.hasAttribute('data-custom-product') && monoKey !== '') {
        const { key, feeKey } = this.dataset

        const data = {
          [key]: 0
        }

        if (!!feeKey) {
          data[feeKey] = 0
        }

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: data })
        })
          .then((response) => {
            return response.json()
          })
          .catch((error) => {
            console.error('Error:', error)
          })
          .then(() => {
            cartItems.renderCartDrawer()
          })
      } else {
        cartItems.updateQuantity(this.dataset.index, 0)
      }
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
  isCartDrawerRendering = false

  constructor() {
    super()
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus')

    const debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, ON_CHANGE_DEBOUNCE_TIMER)

    this.addEventListener('change', debouncedOnChange.bind(this))

    document.addEventListener('custom:cart:refresh', () => {
      this.renderCartDrawer(true)
    })

    document.addEventListener('custom:cart:refresh:remove', () => {
      this.renderCartDrawer(true)
    })

    document.addEventListener('custom:cart:upsells:ready', () => {
      setTimeout(() => {
        this.fixStuckRebuyWidgets()
      }, 250)
    })
  }

  cartUpdateUnsubscriber = undefined

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return
      }
      this.onCartUpdate()
    })
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber()
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'))
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const sourceQty = html.querySelector('cart-items')
        this.innerHTML = sourceQty.innerHTML
      })
      .catch((e) => {
        console.error(e)
      })
  }

  async updateCartCount() {
    const counterEl = document.querySelector('[data-cart-count]')
    const bubbleEl = document.querySelector('[data-cart-counter-bubble]')
    const counterADAEl = document.querySelector('[data-cart-count-ada]')
    if (!counterEl || !bubbleEl || !counterADAEl) return

    try {
      const cartJsonResponse = await fetch('/cart.json')
      const cartData = await cartJsonResponse.json()

      const count = cartData.items.reduce((acc, item) => {
        if (item.product_type === 'Monogram Fee') return acc

        return acc + item.quantity
      }, 0)

      counterEl.textContent = count
      counterADAEl.textContent = `${count} items`

      if (!count) {
        bubbleEl.classList.add('hidden')
      } else {
        bubbleEl.classList.remove('hidden')
      }
    } catch (error) {
      console.error('Error on updating cart count:', error)
      return
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents'
      }
    ]
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    })

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`)
        const items = document.querySelectorAll('.cart-item')

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value')
          this.updateLiveRegions(line, parsedState.errors)
          return
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0)
        const cartDrawerWrapper = document.querySelector('cart-drawer')
        const cartFooter = document.getElementById('main-cart-footer')

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0)

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
        })

        this.updateCartCount()

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined
        let message = ''
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue)
          }
        }
        this.updateLiveRegions(line, message)

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`)
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus()
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' })
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'))
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
      })
      .finally(() => {
        this.disableLoading(line)
      })
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`)
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message

    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.add('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`)
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`)

    ;[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'))

    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)

    publish(PUB_SUB_EVENTS.cartLoading, { source: 'cart-items' })
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.remove('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`)
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`)

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'))
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'))

    publish(PUB_SUB_EVENTS.cartUnloading, { source: 'cart-items' })
  }

  async renderCartDrawer(isRebuy = false) {
    // Avoid multiple rendering at the same time
    if (this.isCartDrawerRendering) return

    this.isCartDrawerRendering = true

    if (window.location.href.indexOf('cart') != -1) {
      window.location.reload()
    }

    if (this.tagName != 'CART-DRAWER-ITEMS') {
      this.isCartDrawerRendering = false
      return
    }

    try {
      const newCartDom = await this.fetchCartDrawerContent()
      if (!newCartDom) {
        throw new Error('Cannot fetch cart drawer content')
      }

      const newCartDrawerItemsEl = newCartDom.querySelector('cart-drawer-items, cart-items')
      this.innerHTML = newCartDrawerItemsEl?.innerHTML || this.innerHTML

      const newCartDrawerEl = newCartDom.querySelector('cart-drawer')
      const isEmptyCart = newCartDrawerEl?.classList.contains('is-empty')
      if (isEmptyCart) {
        this.renderCartDrawerEmpty(newCartDom)
      } else {
        this.renderCartDrawerItems(newCartDom)
      }

      const currCartDrawerEl = document.querySelector('cart-drawer')
      if (!isRebuy && !currCartDrawerEl?.classList.contains('active')) {
        currCartDrawerEl?.open()
      }

      await this.updateCartCount()
      publish(PUB_SUB_EVENTS.cartUnloading, { source: 'cart-items' })
    } catch (error) {
      console.error('Error on rendering cart:', error)
    }

    this.isCartDrawerRendering = false
  }

  async fetchCartDrawerContent() {
    try {
      const response = await fetch('/cart?section_id=cart-drawer')
      const html = await response.text()
      return new DOMParser().parseFromString(html, 'text/html')
    } catch (error) {
      console.error('Error on fetching cart drawer content:', error)
    }
  }

  renderCartDrawerEmpty(newCartDom) {
    const currCartDrawerEl = document.querySelector('cart-drawer')
    if (!currCartDrawerEl) return

    this.classList.add('is-empty')
    currCartDrawerEl.classList.add('is-empty')

    const currCartEmptyEl = document.querySelector('.drawer__inner-empty')
    const newCartEmptyEl = newCartDom.querySelector('.drawer__inner-empty')
    if (!currCartEmptyEl || !newCartEmptyEl) return

    currCartEmptyEl.innerHTML = newCartEmptyEl.innerHTML
  }

  renderCartDrawerItems(newCartDom) {
    const currCartDrawerEl = document.querySelector('cart-drawer')
    if (!currCartDrawerEl) return

    this.classList.remove('is-empty')
    currCartDrawerEl.classList.remove('is-empty')

    const currCartEmptyEl = document.querySelector('.drawer__inner-empty')
    if (currCartEmptyEl) {
      currCartEmptyEl.innerHTML = ''
    }

    const currCartFooterEl = document.querySelector('.drawer__footer')
    const newCartFooterEl = newCartDom.querySelector('.drawer__footer')
    if (currCartFooterEl && newCartFooterEl) {
      currCartFooterEl.innerHTML = newCartFooterEl.innerHTML
    }

    // Fix missing upsells widget after adding from empty cart
    const currCartUpsellsEl = document.querySelector('.drawer__upsells')
    const newCartUpsellsEl = newCartDom.querySelector('.drawer__upsells')
    if (!currCartUpsellsEl && newCartUpsellsEl) {
      this.insertAdjacentElement('afterend', newCartUpsellsEl)
    }

    window.cart_counter?.()
  }

  fixStuckRebuyWidgets() {
    if (!window.Rebuy?.widgets?.length || this.isCartDrawerRendering) return

    // Rebuy sometimes fails to reinit widgets due to duplicate widget IDs in its data, causing a "reinitializing" status.
    // We have to force a full reinit of all widgets to handle this.
    const stuckWidget = window.Rebuy.widgets.find((widget) => widget.status === 'reinitializing')
    if (!stuckWidget) return

    window.Rebuy.reinit?.()
  }
}

customElements.define('cart-items', CartItems)

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super()

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value })
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          }, ON_CHANGE_DEBOUNCE_TIMER)
        )
      }
    }
  )
}

// ==== Start Cart Monogram Validator ====
const cartMonogramValidator = {
  validateAndUpdate: debounce(async (callback) => {
    const isValidatorEnabled = window.__GLOBAL__.monogramCustomizer.enableCartValidator
    if (!isValidatorEnabled) {
      console.warn('Cart monogram validator is disabled')
      callback?.()

      return
    }

    const cartData = await fetch('/cart.js').then((response) => response.json())
    if (!cartData.items.length) return

    const { items } = cartData
    const invalidItems = [
      ...cartMonogramValidator.getInvalidGroupItems(items),
      ...cartMonogramValidator.getInvalidSingleMonogramFeeItems(items),
      ...(await cartMonogramValidator.getInvalidIdTagsItems(items))
    ]
    if (!invalidItems.length) return

    await cartMonogramValidator.updateInvalidItems(invalidItems)

    callback?.()
  }, 500),

  getMonogramGroups(items) {
    const monogramGroups = {}

    items.forEach((item) => {
      if (!cartMonogramValidator.isMonogramItem(item)) return

      const monogramKey = item.properties._monogram_key
      monogramGroups[monogramKey] ??= []
      monogramGroups[monogramKey].push(item)
    })

    return monogramGroups
  },

  getInvalidGroupItems(items) {
    const monogramGroups = cartMonogramValidator.getMonogramGroups(items)

    if (!Object.keys(monogramGroups).length) return []

    const invalidGroups = Object.values(monogramGroups).filter((group) => !cartMonogramValidator.isValidGroup(group))
    console.log('Invalid monogram groups:', structuredClone(invalidGroups))

    invalidGroups.forEach(cartMonogramValidator.correctInvalidGroupQuantity)
    console.log('Corrected invalid monogram groups:', structuredClone(invalidGroups))

    return invalidGroups.flat()
  },

  getInvalidSingleMonogramFeeItems(items) {
    // Filter out fee items but not belong to any group
    const invalidItems = items.filter((item) => cartMonogramValidator.isMonogramFeeItem(item) && !cartMonogramValidator.isMonogramItem(item))
    console.log('Invalid single monogram fee items:', structuredClone(invalidItems))

    invalidItems.forEach((item) => (item.quantity = 0))
    console.log('Corrected invalid single monogram fee items:', structuredClone(invalidItems))

    return invalidItems
  },

  async getInvalidIdTagsItems(items) {
    const root = window.Shopify.routes.root
    const itemProducts = await Promise.all(
      items.map((item) =>
        fetch(`${root}products/${item.handle}.json`)
          .then((response) => response.json())
          .then((response) => response.product)
      )
    )

    // Filter out id tags items that are not monogram items
    const invalidItems = items.filter((item, index) => {
      const itemProduct = itemProducts[index]
      const isIdTag = itemProduct.tags.includes('id-tags') && item.sku !== 'TAG-103'
      const isMonogramItem = cartMonogramValidator.isMonogramItem(item)

      return isIdTag && !isMonogramItem
    })
    console.log('Invalid id tags items:', structuredClone(invalidItems))

    invalidItems.forEach((item) => (item.quantity = 0))
    console.log('Corrected invalid id tags items:', structuredClone(invalidItems))

    return invalidItems
  },

  async updateInvalidItems(items) {
    console.log('Updating invalid items:', structuredClone(items))

    const formData = new FormData()
    items.forEach((item) => {
      formData.append(`updates[${item.key}]`, item.quantity)
    })

    try {
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        body: formData
      })

      alert(window.cartStrings.invalidMessage)
    } catch (error) {
      console.error('Error on removing invalid monogram items', error)
    } finally {
      window.location.reload()
    }
  },

  correctInvalidGroupQuantity(invalidGroup) {
    if (cartMonogramValidator.isValidGroupWithoutFee(invalidGroup)) return

    const mainItem = invalidGroup.find((item) => !cartMonogramValidator.isMonogramFeeItem(item))
    const isBundle = mainItem?.properties._is_monogram_bundle === 'Yes'

    // If bundle but invalid, just remove everything
    if (isBundle) {
      invalidGroup.forEach((item) => (item.quantity = 0))
      return
    }

    // If not bundle, try to correct quantity between main and fee items, remove if missing
    const feeItem = invalidGroup.find(cartMonogramValidator.isMonogramFeeItem)
    const mainItemQuantity = feeItem ? (mainItem?.quantity ?? 0) : 0 // If missing fee, remove main item
    const feeItemQuantity = mainItemQuantity // Fee quantity must always match main item quantity, remove if missing

    if (mainItem) mainItem.quantity = mainItemQuantity
    if (feeItem) feeItem.quantity = feeItemQuantity
  },

  isValidGroup(group) {
    return (
      cartMonogramValidator.isValidGroupWithoutFee(group) ||
      cartMonogramValidator.isValidGroupWithFee(group) ||
      cartMonogramValidator.isValidGroupOfBundle(group)
    )
  },

  isValidGroupWithoutFee(group) {
    const item = group[0]
    const onlyOneItem = group.length === 1
    const notMonogramFee = !cartMonogramValidator.isMonogramFeeItem(item)
    const monogramFeeProp = Object.keys(item.properties).find((key) => key.endsWith('_monogram_fee'))
    const notHasMonogramFeeProp = !monogramFeeProp

    return onlyOneItem && notMonogramFee && notHasMonogramFeeProp
  },

  isValidGroupWithFee(group) {
    const feeItem = group.find(cartMonogramValidator.isMonogramFeeItem)
    const mainItem = group.find((item) => !cartMonogramValidator.isMonogramFeeItem(item))
    if (!feeItem || !mainItem) return false

    const exactTwoItems = group.length === 2
    const mustMatchQuantity = feeItem.quantity === mainItem?.quantity
    return exactTwoItems && mustMatchQuantity
  },

  isValidGroupOfBundle(group) {
    const mainItem = group.find((item) => !cartMonogramValidator.isMonogramFeeItem(item))
    if (mainItem?.properties._is_monogram_bundle !== 'Yes') return false

    const feeItems = group.filter(cartMonogramValidator.isMonogramFeeItem)
    const feeItemsQuantity = feeItems.reduce((acc, item) => acc + item.quantity, 0)
    const monogramFeeProps = Object.keys(mainItem.properties).filter((key) => key.endsWith('_monogram_fee'))
    if (feeItemsQuantity !== monogramFeeProps.length) return false

    return true
  },

  isMonogramFeeItem(item) {
    return item.handle === 'monogram-fee' || item.title.startsWith('Personalization Fee') || item.properties._is_monogram_fee === 'Yes'
  },

  isMonogramItem(item) {
    return !!item.properties?._monogram_key?.length
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Run initial validation
  cartMonogramValidator.validateAndUpdate()
})
// ==== End Cart Monogram Validator ====

/**
 * ==== Start Cart Checkout Button ====
 *
 * Here we add custom logic for checkout button that triggered on cart state change
 * We want to lock checkout button if any cart requests are in progress
 * and also validate + correct monogram items before allowing checkout
 */
class CartCheckoutButton extends HTMLButtonElement {
  unsubscribeCartLoading = undefined
  unsubscribeCartUnloading = undefined

  constructor() {
    super()

    // We don't want complex logic inside releaseCheckout run too often
    this.releaseCheckout = window.debounce(this.releaseCheckout.bind(this), 1000)
  }

  connectedCallback() {
    this.unsubscribeCartLoading = subscribe(PUB_SUB_EVENTS.cartLoading, (event) => {
      if (event.source !== 'cart-items') return
      // this.setAttribute('disabled', 'true')
    })

    this.unsubscribeCartUnloading = subscribe(PUB_SUB_EVENTS.cartUnloading, (event) => {
      if (event.source !== 'cart-items') return
      this.releaseCheckout()
    })
  }

  disconnectedCallback() {
    this.unsubscribeCartLoading?.()
    this.unsubscribeCartUnloading?.()
  }

  releaseCheckout() {
    cartMonogramValidator.validateAndUpdate(() => {
      this.removeAttribute('disabled')
    })
  }
}

if (!customElements.get('cart-checkout-button')) {
  customElements.define('cart-checkout-button', CartCheckoutButton, { extends: 'button' })
}
//  ==== End Cart Checkout Button ====
